import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "./Header";
import { Container, Row, Col } from "react-bootstrap";
import Footer from "./Footer";

function MyTransaction() {
  let server_url = localStorage.getItem("server_url");
  let dealer_id = localStorage.getItem("dealer_id");
  const [orderds, setOrderds] = useState([]);
  const [loading, setLoading] = useState(false);

  const today = new Date().toISOString().split("T")[0]; // Today's date (YYYY-MM-DD)
  const pastDate = new Date();
  pastDate.setDate(pastDate.getDate() - 30);
  const last30Days = pastDate.toISOString().split("T")[0]; // Last 30 days date (YYYY-MM-DD)
  const [from, setFrom] = useState(last30Days);
  const [to, setTo] = useState(today);

  useEffect(() => {
    get_transaction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to]);

  const get_transaction = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("from", from);
      formData.append("to", to);
      const res = await axios.post(
        `${server_url}transaction_list.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.data.status === "1") {
        setOrderds(res.data.result);
      } else {
        setOrderds([]);
        // toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    } finally {
      setLoading(false);
    }
  };

  const overdueAmount = localStorage.getItem("local_overdue_amount") || "0";
  const outstandingAmount = localStorage.getItem("local_dealer_os") || "0";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="page-wrapper">
        {/* Header - Always Sticky */}
        <div className="sticky-header">
          <Header />
        </div>

        <div className="transaction-content">
          <Container className="py-4">
            {/* Sticky Container for Date Filter and Summary Cards */}
            <div className="sticky-top-section">
              {/* Date Filter Section - Sticky */}
              <div className="sticky-date-filter">
                <Row className="mb-4 g-3">
                  <Col xs={6} md={6}>
                    <label htmlFor="from-date" className="form-label">
                      From Date
                    </label>
                    <input
                      id="from-date"
                      type="date"
                      className="form-control date-input"
                      value={from}
                      onChange={(e) => setFrom(e.target.value)}
                    />
                  </Col>
                  <Col xs={6} md={6}>
                    <label htmlFor="to-date" className="form-label">
                      To Date
                    </label>
                    <input
                      id="to-date"
                      type="date"
                      className="form-control date-input"
                      value={to}
                      onChange={(e) => setTo(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>

              {/* Summary Cards - Sticky and same layout for both web and mobile */}
              <div className="sticky-summary-cards">
                <Row className="g-3" style={{ marginBottom: "0px" }}>
                  <Col xs={6} md={6}>
                    <div className="summary-card overdue">
                      {!isMobile && (
                        <div className="summary-icon">
                          <i className="fa fa-star"></i>
                        </div>
                      )}
                      <div className="summary-content">
                        <h5 className="summary-label">Overdue</h5>
                        <h3 className="summary-value">{overdueAmount}</h3>
                      </div>
                    </div>
                  </Col>
                  <Col xs={6} md={6}>
                    <div className="summary-card outstanding">
                      {!isMobile && (
                        <div className="summary-icon">
                          <i className="fa fa-clock"></i>
                        </div>
                      )}
                      <div className="summary-content">
                        <h5 className="summary-label">Outstanding</h5>
                        <h3 className="summary-value">{outstandingAmount}</h3>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            {/* Spacer to prevent content from being hidden behind sticky elements */}

            {/* Transactions List */}
              <h4 className="section-title mb-3" style={{marginTop:isMobile ? "70px" : "10px", color: "#000000"}}>Transaction History</h4>
              {loading ? (
                <div className="loading-placeholder">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2" style={{ color: "#666666" }}>Loading transactions...</p>
                </div>
              ) : orderds.length > 0 ? (
                <div className="transactions-list">
                  {orderds.map((item) => (
                    <div key={item.transaction_id} className="transaction-item">
                      <div className="transaction-header">
                        <div className="transaction-id" style={{ color: "#000000" }}>
                          #{item.transaction_id}
                        </div>
                        <div
                          className={`transaction-amount ${
                            item.transaction_in_out === "1" ? "in" : "out"
                          }`}
                        >
                          <i
                            className={`fa fa-arrow-${
                              item.transaction_in_out === "1" ? "down" : "up"
                            } me-1`}
                          ></i>
                          {item.transaction_amount}
                        </div>
                      </div>
                      <p className="transaction-remark" style={{ color: "#333333" }}>
                        {item.transaction_remark}
                      </p>
                      <div className="transaction-date" style={{ color: "#666666" }}>
                        {item.transaction_date}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-state text-center py-5">
                  <i
                    className="fa fa-exchange-alt fa-3x mb-3"
                    style={{ color: "#999999" }}
                  ></i>
                  <h5 style={{ color: "#000000" }}>No transactions found.</h5>
                  <p className="mb-0" style={{ color: "#666666" }}>
                    Try adjusting the date range.
                  </p>
                </div>
              )}
          </Container>
        </div>

       {isMobile ? <><br/><br/></> : ""}

        <Footer />
      </div>

      <style jsx>{`
        .page-wrapper {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .transaction-content {
          flex: 1;
          background: #ffffff;
          min-height: 100vh;
          color: #000000;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif;
        }

        /* Sticky Header */
        .sticky-header {
          position: sticky;
          top: 0;
          z-index: 1000;
          width: 100%;
        }

        /* Sticky Top Section Container */
        .sticky-top-section {
          position: sticky;
          top: 66px; /* Adjust based on your header height */
          z-index: 999;
          background: #ffffff;
          margin: 0 -15px;
          padding-left: 15px;
          padding-right: 15px;
          border-bottom: 1px solid #e5e5e5;
        }

        /* Sticky Date Filter */
        .sticky-date-filter {
          background: #ffffff;
        }

        /* Sticky Summary Cards */
        .sticky-summary-cards {
          background: #ffffff;
          padding-bottom: 1rem;
          border-bottom: 1px solid #f0f0f0;
        }

        /* Spacer to prevent content hiding */
        .sticky-spacer {
          height: 280px; /* Adjust based on the total height of sticky sections */
        }

        @media (max-width: 768px) {
          .sticky-top-section {
            top: 66px; /* Same as web for consistency */
          }

          .sticky-spacer {
            height: 280px; /* Same as web for consistent layout */
          }
        }

        .form-control:focus {
          color: #000000;
        }

        .form-label {
          color: #000000;
          font-weight: 600;
          margin-bottom: 0.5rem;
          display: block;
        }

        .date-input {
          background: #ffffff;
          border: 1px solid #e5e5e5;
          color: #000000;
          border-radius: 8px;
          padding: 0.75rem;
          font-size: 1rem;
        }

        .date-input:focus {
          border-color: #db4437;
          box-shadow: 0 0 0 0.2rem rgba(219, 68, 55, 0.25);
          background: #ffffff;
        }

        .date-input::-webkit-calendar-picker-indicator {
          filter: invert(0);
        }

        /* Summary Cards - Same layout for both web and mobile */
        .summary-card {
          background: #ffffff;
          border-radius: 12px;
          padding: 1rem;
          border: 1px solid #e5e5e5;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          height: 100%;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
          min-height: 80px; /* Consistent height */
        }

        .summary-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          border-color: #db4437;
        }

        .overdue {
          border-left: 4px solid #ef4444;
        }

        .outstanding {
          border-left: 4px solid #10b981;
        }

        .summary-icon {
          width: 50px;
          height: 50px;
          background: #f8f9fa;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1rem;
          flex-shrink: 0;
          border: 1px solid #f0f0f0;
        }

        .overdue .summary-icon i {
          color: #ef4444;
          font-size: 1.2rem;
        }

        .outstanding .summary-icon i {
          color: #10b981;
          font-size: 1.2rem;
        }

        .summary-content {
          flex-grow: 1;
        }

        .summary-label {
          color: #666666;
          font-weight: 600;
          margin-bottom: 0.25rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .summary-value {
          color: #000000;
          font-weight: 700;
          margin: 0;
        }

        .overdue .summary-value {
          color: #ef4444;
        }

        .outstanding .summary-value {
          color: #10b981;
        }

        /* Section Title */
        .section-title {
          color: #000000;
          font-weight: 600;
          border-bottom: 2px solid #db4437;
          padding-bottom: 0.5rem;
          display: inline-block;
        }

        /* Transactions List */
        .transactions-section {
          background: #f8f9fa;
          border-radius: 12px;
          padding: 1.5rem;
          border: 1px solid #e5e5e5;
        }

        .transactions-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .transaction-item {
          background: #ffffff;
          border-radius: 8px;
          padding: 1rem;
          border-left: 3px solid #db4437;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          border: 1px solid #f0f0f0;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
        }

        .transaction-item:hover {
          background: #f8f9fa;
          transform: translateX(4px);
          border-color: #db4437;
        }

        .transaction-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.5rem;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .transaction-id {
          color: #000000;
          font-size: 1rem;
          font-weight: 600;
        }

        .transaction-amount {
          font-size: 1rem;
          font-weight: 700;
          display: flex;
          align-items: center;
        }

        .transaction-amount.in {
          color: #10b981;
        }

        .transaction-amount.in i {
          color: #10b981;
        }

        .transaction-amount.out {
          color: #ef4444;
        }

        .transaction-amount.out i {
          color: #ef4444;
        }

        .transaction-remark {
          color: #333333;
          font-size: 0.9rem;
          margin: 0 0 0rem 0;
          line-height: 1.4;
        }

        .transaction-date {
          color: #666666;
          font-size: 0.8rem;
          align-self: flex-end;
          text-align: right;
        }

        /* Loading and Empty States */
        .loading-placeholder {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 3rem;
        }

        .empty-state i {
          color: #db4437;
        }

        .empty-state h5 {
          color: #000000;
          margin-bottom: 0.5rem;
        }

        .empty-state p {
          color: #666666;
        }

        /* Responsive Design - Remove mobile-specific summary card changes */
        @media (max-width: 768px) {
          .summary-card {
            padding: 1.5rem; /* Keep same padding */
            flex-direction: row; /* Keep horizontal layout */
            text-align: left; /* Keep left alignment */
            min-height: 80px; /* Same height as web */
          }

          .summary-icon {
            margin-right: 1rem; /* Keep margin */
            margin-bottom: 0; /* Remove bottom margin */
          }

          .summary-value {
            font-size: 1.5rem; /* Keep same font size */
          }

          .transaction-header {
            width: 20%;
            flex-direction: column;
            align-items: flex-start;
            gap: 0.25rem;
          }

          .transaction-amount {
            align-self: flex-end;
          }

          .transactions-section {
            padding: 1rem;
          }

          .section-title {
            font-size: 1.25rem;
          }
        }

        @media (max-width: 480px) {
          .date-input {
            font-size: 0.9rem;
            padding: 0.625rem;
          }

          .summary-card {
            padding: 1.25rem; /* Slightly reduced but still horizontal */
          }

          .summary-icon {
            width: 45px;
            height: 45px;
            margin-right: 0.875rem;
          }

          .summary-value {
            font-size: 1.3rem;
          }

          .transaction-item {
            padding: 0.875rem;
          }

          .transaction-id,
          .transaction-amount {
            font-size: 0.95rem;
          }
        }

        /* Touch optimizations */
        @media (hover: none) and (pointer: coarse) {
          .transaction-item:hover,
          .summary-card:hover {
            transform: none;
          }
        }
          .date-input{
          background: #f4f1f1;
    border: 1px solid #f4f1f1;
          }
      `}</style>
    </React.Fragment>
  );
}

export default MyTransaction;